"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var WalletProvider_1 = require("../providers/WalletProvider");
var ConnectionProvider_1 = require("../providers/ConnectionProvider");
/**
 * Combined provider for Solana wallet and connection
 *
 * This component combines both the ConnectionProvider and WalletProvider
 * for easier setup of Solana wallet functionality in React applications.
 *
 * It supports custom storage mechanisms via the storageFactory prop.
 *
 * @param props HermisWalletProviderProps
 * @returns Provider component
 */
var ContextProvider = function (_a) {
    var children = _a.children, adapters = _a.adapters, rpcEndpoint = _a.rpcEndpoint, network = _a.network, _b = _a.autoConnect, autoConnect = _b === void 0 ? false : _b, _c = _a.storageKey, storageKey = _c === void 0 ? 'walletName' : _c, storageFactory = _a.storageFactory, onError = _a.onError;
    var connectionConfig = (0, react_1.useMemo)(function () { return ({
        commitment: 'confirmed',
    }); }, []);
    return ((0, jsx_runtime_1.jsx)(ConnectionProvider_1.ConnectionProvider, { network: network, endpoint: rpcEndpoint, config: connectionConfig, children: (0, jsx_runtime_1.jsx)(WalletProvider_1.WalletProvider, { wallets: adapters, autoConnect: autoConnect, storageKey: storageKey, storageFactory: storageFactory, onError: onError, children: children }) }));
};
exports.ContextProvider = ContextProvider;
